import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Check, Timer, X } from "lucide-react";
import { getSundayPromo } from "../lib/promo";

function SundayPromo() {
  const [promo, setPromo] = useState(getSundayPromo());
  useEffect(() => {
    const timer = setInterval(() => setPromo(getSundayPromo()), 1000);
    return () => clearInterval(timer);
  }, []);

  if (!promo.active) {
    return (
      <div className="promo-box" data-testid="sunday-promo-inactive">
        <div className="promo-line"><span>Pacote com 10 capas</span><strong>R$ 84,90</strong></div>
        <p className="promo-note">Aos domingos, das 6h às 6h de segunda-feira (horário de Brasília), o pacote com 10 capas sai por <b>R$ 50</b>. Volte no domingo e aproveite.</p>
      </div>
    );
  }

  return (
    <div className="promo-box is-live" data-testid="sunday-promo-active">
      <div className="promo-badge"><span className="pulse-dot" /> PROMOÇÃO DE DOMINGO ATIVA</div>
      <div className="promo-line">
        <span>10 capas por</span>
        <strong data-testid="promo-price">R$ 50 <s>R$ 84,90</s></strong>
      </div>
      <div className="cd-cells" data-testid="promo-countdown">
        {[["HORAS", promo.hours], ["MIN", promo.minutes], ["SEG", promo.seconds]].map(([label, value]) => (
          <div className="cd-cell" key={label} data-testid={`countdown-${label.toLowerCase()}`}>
            <b>{value}</b><span>{label}</span>
          </div>
        ))}
      </div>
      <p className="promo-note">Válida até segunda-feira, 6h (horário de Brasília). Depois disso, o pacote volta a R$ 84,90.</p>
    </div>
  );
}

export default function ServiceModal({ service, close, onQuote }) {
  const Icon = service.icon;
  return (
    <motion.div className="modal-backdrop" onMouseDown={close}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}>
      <motion.div className="quote-modal service-modal" onMouseDown={(e) => e.stopPropagation()} data-testid={`service-modal-${service.id}`}
        initial={{ opacity: 0, y: 44, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 24, scale: 0.98 }} transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}>
        <button className="modal-close" onClick={close} data-testid={`close-service-modal-${service.id}`} aria-label="Fechar"><X /></button>
        <div className="eyebrow"><i /> SABER MAIS</div>
        <div className="sm-head">
          <span className="sm-icon"><Icon size={26} /></span>
          <h2>{service.name}</h2>
        </div>
        <p className="modal-intro">{service.modalIntro}</p>
        <ul className="sm-bullets">
          {service.modalBullets.map((item) => (
            <li key={item}><Check size={14} /> {item}</li>
          ))}
        </ul>
        {service.modalNote && <p className="sm-note">{service.modalNote}</p>}
        <div className="sm-price" data-testid={`service-modal-price-${service.id}`}>{service.price}</div>
        {service.hasSundayPromo && <SundayPromo />}
        <button className="button button-primary full" onClick={() => onQuote(service)} data-testid={`service-modal-quote-${service.id}`}>
          Quero este serviço <ArrowUpRight size={17} />
        </button>
        <p className="sm-foot"><Timer size={13} /> Valores e prazos confirmados diretamente com Vieira no atendimento.</p>
      </motion.div>
    </motion.div>
  );
}
